import { module as BaseModule } from 'modujs';
import { html } from '../utils/dom';

import gsap from 'gsap';
import Swiper from 'swiper';
import { Pagination, Keyboard } from 'swiper/modules';

const OFFSET_SLIDES = 2;

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        prev: 'showPreviousSlide',
        next: 'showNextSlide',
        close: 'close'
      },
      submit: 'submitData'
    }

    this.currentSlide = 0;
    this.timeline = gsap.timeline();
    this.loader = this.$('loader')[0];
    this.content = this.$('content')[0];
    this.progress = this.$('progress')[0];
  }

  open( profile ) {
    html.classList.add('has-quiz-open');
    this.el.classList.add('is-loading');
    //this.$('slide')[ 0 ].classList.add('is-active');

    let url = RSQ_XHR.api + 'rs/v1/quiz';
    if ( '' !== profile && 'generic' !== profile ) {
      url += '/' + profile;
    }

    // Update name for RDS
    this.el.children[0].setAttribute('name', `quiz-form-${profile}`);

    fetch( url, {
      method: 'GET',
      security: 'same-credentials'
    } )
      .then( res => res.ok ? res.json() : Promise.reject(res) )
      .then( response => {
        const spinner = this.$('slide.-spinner')[0];
        const submit = this.$('slide.-submit')[0];
        this.$('content')[0].innerHTML = response.rendered;
        this.$('content')[0].insertAdjacentHTML(
          'beforeend', spinner.outerHTML + submit.outerHTML
        );
        this.$('name')[0].addEventListener('keypress', ev => {
          if (13 === ev.which) {
            ev.preventDefault();
            this.showNextSlide();
          }
        });
        this.loadInnerSliders();
        //this.el.showModal();
        //this.$('slide')[ 0 ].classList.add('is-active');
        this.$('profile')[0].setAttribute('value', profile || '');
        this.progress.setAttribute('max', this.$('slide').length - OFFSET_SLIDES);
        this.el.classList.remove('is-loading');
      } )
    ;

    this.el.showModal();
  }

  close() {
    html.classList.remove('has-quiz-open');
    //this.$('slide')[ this.currentSlide ].classList.remove('is-active');
    this.$('profile')[0].setAttribute('value', null);
    this.progress.setAttribute('value', 0);
    this.progress.setAttribute('max', OFFSET_SLIDES);
    this.currentSlide = 0;
    this.el.close();
    //this.$('content')[0].innerHTML = '';
  }

  showPreviousSlide() {
    this.showSlide( this.currentSlide - 1 );
  }

  showNextSlide() {
    this.showSlide( this.currentSlide + 1 );
  }

  showSlide(n) {
    if ( this.timeline.isActive() ) {
      return;
    }

    //const quizContent = document.getElementsByClassName('c-quiz_content');

    this.timeline
      .to(this.content, {
        duration: 0.4,
        opacity: 0,
        onStart: () => {
          // Update the progress bar.
          if (n >= 0) {
            gsap.to( this.progress, 1, {
              value: n,
            } );
          }
        },
        onComplete: () => {
          this.disableSlide();
          if (n === this.$('slide').length - OFFSET_SLIDES) {

            this.hideNavigation();
          }
        }
      })
      .to(this.content, {
        duration: 1.0,
        ease: 'power1.out',
        opacity: 1,
        onStart: () => {
          //console.log( this.$('slide') );
          this.$('slide')[ n ].classList.add('is-active');

          this.$('slide')[ n ].querySelectorAll('[tabindex]')
            .forEach((input, index) => {
              input.setAttribute('tabindex', 0);
            })
          ;

          if (this.currentSlide === 0 && n > 0) {
            this.setupName( this.$('name')[0].value );
          }

          this.currentSlide = n;

          // Update navigation buttons visibility/status.
          if (this.currentSlide === 0) {
            this.$('prev')[0].setAttribute('disabled', 'disabled');
          } else {
            this.$('prev')[0].removeAttribute('disabled');
            this.$('prev')[0].setAttribute('tabindex', 0);
          }

          if (this.currentSlide === this.$('slide').length - OFFSET_SLIDES) {
            this.$('next')[0].setAttribute('disabled', 'disabled');
            //this.$('submit')[0].classList.remove('u-hidden');
            //this.$('submit')[0].removeAttribute('disabled');
          } else {
            this.$('next')[0].removeAttribute('disabled');
            //this.$('submit')[0].classList.add('u-hidden');
          }
        },
        onComplete: () => {
          if (n === this.$('slide').length - OFFSET_SLIDES) {
            this.runLoader();
          }
        }
      })
    ;
  }

  disableSlide() {
    // Update slide visibility and tabindex for inputs.
    this.$('slide.is-active').forEach(slide => {
      slide.querySelectorAll('[tabindex]')
        .forEach(input => input.setAttribute('tabindex', -1))
      ;
      slide.classList.remove('is-active');
    });
  }

  runLoader() {
    gsap
      .to(this.$('spinnerProgress')[0], {
        duration: 6,
        ease: 'linear',
        strokeDashoffset: 0,
        onComplete: () => {
          window.setTimeout(() => {
            grecaptcha.ready(() => {
              grecaptcha.execute(
                '6LcxXpMfAAAAAJrdGmd8q52znxkziFRkLqqNSpph',
                {
                  action: 'quiz'
                }
              ).then(token => {
                this.$('recaptcha')[0].setAttribute('value', token);
              });
            });

            this.showNextSlide();
          }, 200);
        }
      })
    ;
  }

  hideNavigation() {
    this.$('navigation')[0].classList.add('is-hidden');
  }

  submitData(ev) {
    ev.preventDefault();

    const responseElement = this.$('response')[0];
    const submitButton = this.$('submit')[0];
    const submitButtonOriginalContent = submitButton.innerHTML;
    const formData = new FormData(ev.target);

    formData.append('sec', RSQ_XHR.sec);

    const cookieObj = Object.fromEntries(document.cookie.split('; ').map(v=>v.split(/=(.*)/s).map(decodeURIComponent)));
    //const cookieMap = new Map(document.cookie.split('; ').map(v=>v.split(/=(.*)/s).map(decodeURIComponent)));

    if ( '__trf.src' in cookieObj ) {
      formData.append( 'traffic_source', cookieObj['__trf.src'] );
    }

    submitButton.setAttribute('disabled', true);
    submitButton.children[1].textContent = 'Enviando…';
    responseElement.innerHTML = '';

    fetch(RSQ_XHR.url, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(response => {
        //console.log( response );
        if (response.success) {
          if (response.data.url) {
            //console.log( response.data.url );
            window.setTimeout(() => {
              //console.log('trying to redirect to: ' + response.data.url);
              window.location.assign( response.data.url );
            }, 1000);
          }
        } else {
          //const errorField = formElement.querySelector(SELECTOR.ERROR + response.data.selector);
          //errorField.innerHTML = response.data.message;
          responseElement.innerHTML = response.data.message;
          submitButton.innerHTML = submitButtonOriginalContent;
          submitButton.disabled = false;
        }
      })
      .catch(err => {
        console.error(err.message);
        //submitButton.innerHTML = submitButtonOriginalContent;
        //submitButton.disabled = false;
      })
    ;
  }

  setupName(name = '') {
    const latinNameRegex = /[^a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ,' ']/g;
    this.$('name').forEach(elem => {
      if (elem.nodeName === 'SPAN') {
        let safeName = name.replace(latinNameRegex, '').trim();
        if(elem.innerHTML.includes('{name}')) {
          elem.innerHTML = elem.innerHTML.replace('{name}', safeName);
        } else {
          elem.innerHTML = safeName + ',';
        }
      }
    });
  }

  setupOpenCloseAnimation() {
    const originalShowModal = this.el.showModal;
    const originalClose = this.el.close;

    this.el.showModal = () => {
      originalShowModal.call(this.el);
      this.el.classList.add('is-open');
    };

    this.el.close = () => {
      this.el.addEventListener(
        'transitionend',
        (ev) => originalClose.call(this.el),
        {once: true}
      );
      this.el.classList.remove('is-open');
    }
  }

  initEvents() {
    // Open quiz from the chat bot window
    this.el.addEventListener('rs:open-quiz', ev => {
      this.open( ev.detail.profile );
    });

    // As this event is not cancellable,
    // just remove the class, cannot do the animation.
    this.el.addEventListener('close', ev => {
      html.classList.remove('has-quiz-open');
      this.el.classList.remove('is-open');
    });

    // Close the modal when clicking the overlay
    this.el.addEventListener('click', ev => {
      const dialogDimensions = this.el.getBoundingClientRect();
      if (
        ev.target.nodeName === 'DIALOG' &&
        (
          ev.clientX < dialogDimensions.left ||
          ev.clientX > dialogDimensions.right ||
          ev.clientY < dialogDimensions.top ||
          ev.clientY > dialogDimensions.bottom
        )
      ) {
        this.close();
      }
    });

    // Fill the name for the other steps and go to next one.
    this.$('name')[0].addEventListener('keypress', ev => {
      if (13 === ev.which) {
        ev.preventDefault();
        this.showNextSlide();
      }
    });

  }

  loadInnerSliders() {
    this.$('slide').forEach(slide => {
      const answerSlider = slide.querySelector('.-multiple');
      if ( !!answerSlider ) {
        new Swiper(answerSlider, {
          modules: [ Pagination, Keyboard ],
          a11y: true,
          slidesPerView: 'auto',
          spaceBetween: 10,
          pagination: {
            el: '.swiper-pagination',
          },
          keyboard: {
            enabled: true,
          },
        });
      }
    });
  }

  init() {
    //this.progress.setAttribute('max', this.$('slide').length - OFFSET_SLIDES);
    this.setupOpenCloseAnimation();
    this.initEvents();
    this.loadInnerSliders();
  }
}
